import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import CollegeStorageFeePage from '@/v2/components/pages/public-pages/college-storage-fee-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/college-storage-fee-page'

interface CollegeStorageFeePageProps {}

const Page: React.FC<CollegeStorageFeePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.college_storage_fee.title ?? ''}
        keywords={META_CONTENTS.college_storage_fee?.keywords ?? ''}
        description={META_CONTENTS.college_storage_fee?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />
      <CollegeStorageFeePage />
    </>
  )
}

export default Page
